import { throttle } from 'throttle-debounce'

const isElementInViewport = (element, threshold = 0) => {

    const promise = new Promise((resolve) => {
        //
        const isElementVisible = () => {
            const windowHeight = window.innerHeight
            const elementYToWindow = element.getBoundingClientRect().top
            const heightOffset = element.offsetHeight * threshold

            return elementYToWindow < windowHeight - heightOffset
        }

        const onScrollThrottled = () => {
            const scrolledBeyondThreshold = isElementVisible()

            if(scrolledBeyondThreshold) {
                removeScrollListener()
                resolve()
            }
        }

        const onScroll = throttle(100, onScrollThrottled)

        const addScrollListener = () => {
            window.addEventListener('scroll', onScroll)
        }

        const removeScrollListener = () => {
            window.removeEventListener('scroll', onScroll)
        }

        const elementIsAlreadyInView = isElementVisible()

        if (elementIsAlreadyInView) {
            resolve()
        }
        else {
            addScrollListener()
        }
    })

    return promise
}

export { isElementInViewport }
